/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Entire_DomainInputs */

const en_common_entire_domain = /** @type {(inputs: Common_Entire_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entire domain`)
};

const es_common_entire_domain = /** @type {(inputs: Common_Entire_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el dominio`)
};

/**
* | output |
* | --- |
* | "Entire domain" |
*
* @param {Common_Entire_DomainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_entire_domain = /** @type {((inputs?: Common_Entire_DomainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Entire_DomainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_entire_domain(inputs)
	return en_common_entire_domain(inputs)
});